import { render } from "./QuickLook.vue?vue&type=template&id=0957ca45&ts=true"
import script from "./QuickLook.vue?vue&type=script&lang=ts"
export * from "./QuickLook.vue?vue&type=script&lang=ts"

import "./QuickLook.vue?vue&type=style&index=0&id=0957ca45&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Welcome/QuickLook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0957ca45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0957ca45', __exports__)) {
    api.reload('0957ca45', __exports__)
  }
  
  module.hot.accept("./QuickLook.vue?vue&type=template&id=0957ca45&ts=true", () => {
    api.rerender('0957ca45', render)
  })

}


export default __exports__